import { requiredRule } from '../../utils';
import { RecipeField, FieldType } from './common';

export const CASSANDRA_CONTACT_POINT: RecipeField = {
    name: 'contact_point',
    label: 'Contact Point',
    tooltip: 'Domain or IP address of the Cassandra instance (excluding port).',
    type: FieldType.TEXT,
    fieldPath: 'source.config.contact_point',
    placeholder: 'localhost',
    required: true,
    rules: requiredRule('Contact Point'),
};

export const CASSANDRA_PORT: RecipeField = {
    name: 'port',
    label: 'Port',
    tooltip: 'Port number to connect to the Cassandra instance.',
    type: FieldType.TEXT,
    fieldPath: 'source.config.port',
    placeholder: '9042',
    required: true,
    rules: requiredRule('Port'),
};

export const CASSANDRA_USERNAME: RecipeField = {
    name: 'username',
    label: 'Username',
    tooltip: 'Username credential with read access to the system_schema keyspace.',
    type: FieldType.TEXT,
    fieldPath: 'source.config.username',
    placeholder: 'username',
    required: false,
};

export const CASSANDRA_PASSWORD: RecipeField = {
    name: 'password',
    label: 'Password',
    tooltip: 'Password credential associated with the specified username.',
    type: FieldType.TEXT,
    fieldPath: 'source.config.password',
    placeholder: 'password',
    required: false,
};
